import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Products from "../pages/products/page";
import Contact from "../pages/contact/page";
import Calculations from "../pages/calculations/page";
import ATSCourse from "../pages/ats-course/page";
import Simulator from "../pages/simulator/page";
import FaultsPage from "../pages/faults/page";
import LightingLayout from "../lighting-app/LightingLayout";
import LightingHomePage from "../lighting-app/HomePage";
import DesignNewLightingPage from "../lighting-app/design-new-lighting-wizard/page";
import InspectExistingLightingPage from "../lighting-app/inspect-existing-lighting-wizard/page";
import AdminPage from "../pages/admin/page";
import PlcSimulatorPage from "../pages/plc/page";
import ToolAccessGate from "../components/access/ToolAccessGate";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/calculations", element: <Calculations /> },
  { path: "/products", element: <Products /> },
  { path: "/contact", element: <Contact /> },
  { path: "/ats-course", element: <ATSCourse /> },
  { path: "/simulator", element: <ToolAccessGate service="simulator"><Simulator /></ToolAccessGate> },
  { path: "/faults", element: <ToolAccessGate service="faults"><FaultsPage /></ToolAccessGate> },
  { path: "/plc", element: <ToolAccessGate service="plc"><PlcSimulatorPage /></ToolAccessGate> },
  {
    path: "/lighting",
    element: <ToolAccessGate service="lighting"><LightingLayout /></ToolAccessGate>,
    children: [
      { index: true, element: <LightingHomePage /> },
      { path: "design-new-lighting-wizard", element: <DesignNewLightingPage /> },
      { path: "inspect-existing-lighting-wizard", element: <InspectExistingLightingPage /> },
    ],
  },
  { path: "/admin", element: <AdminPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
